import './alertPresetGlyph.css';

import AlertPresetGlyph from './AlertPresetGlyph';

/** A fire extinguisher, standing on y = 40 with its body centred on `cx`: the object most device alarms are about. */
const extinguisher = (cx: number) => (
    <>
        <rect x={cx - 6} y="19" width="12" height="21" rx="4" />
        <path d={`M${cx - 3} 19v-4h6v4M${cx + 3} 15h5`} />
    </>
);

/**
 * The line drawing on a card of the device alarms: one thin stroke, rounded ends, one part that moves while
 * the card is hovered or focused (`alert-glyph-host`, see alertPresetGlyph.css). The two threshold alarms
 * borrow the gauge and the thermometer of the start cards.
 */
const GLYPHS: Record<string, JSX.Element> = {
    deviceMoving: (
        <>
            <g data-part="shake">{extinguisher(28)}</g>
            <path data-part="trail" d="M8 24h6M6 30h8M9 36h5" />
        </>
    ),
    deviceOverturned: (
        <>
            <g data-part="fallen">{extinguisher(14)}</g>
            <path d="M14 11a19 19 0 0 1 21 7M31.5 12.5l4 5.5-6.5.5" />
        </>
    ),
    sensorFault: (
        <>
            <rect x="15" y="15" width="18" height="18" rx="4" />
            <path d="M20 15v-4M28 15v-4M20 33v4M28 33v4M15 20h-4M15 28h-4M33 20h4M33 28h4" />
            <g data-part="level">
                <path d="M24 20v6" />
                <circle cx="24" cy="29.5" r="0.9" className="fill-current" />
            </g>
        </>
    ),
    capTampered: (
        <>
            <path d="M17 40V29c0-3 2-5 4-6M31 40V29c0-3-2-5-4-6M17 40h14M21 23v-3M27 23v-3" />
            <rect data-part="cap" x="19" y="13" width="10" height="6" rx="2" />
        </>
    ),
    hoseTampered: (
        <>
            <path d="M8 38c0-8 6-10 10-14" />
            <path d="M21 28.5l2.5-1M23 32l-2.5-.5" />
            <g data-part="hose-b">
                <path d="M25 20c3-5 7-4 10-10M33 8l5 4" />
            </g>
        </>
    ),
    pressureHigh: (
        <>
            <path d="M9 34a15 15 0 1 1 30 0" />
            <path d="M9 34h3.5M35.5 34H39M24 19v3.5M13.4 23.4l2.5 2.5M34.6 23.4l-2.5 2.5" />
            <path data-part="needle-high" d="M24 34V21.5" />
            <circle cx="24" cy="34" r="2.1" />
        </>
    ),
};

export default function DeviceAlarmGlyph({ alarm }: { alarm: string }) {
    if (alarm === 'pressureLow') return <AlertPresetGlyph id="pressure" />;
    if (alarm === 'temperatureAlarm') return <AlertPresetGlyph id="temperature" />;

    const glyph = GLYPHS[alarm];

    if (!glyph) return null;

    return (
        <svg
            viewBox="0 0 48 48"
            aria-hidden
            focusable="false"
            className="alert-glyph h-full w-full"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {glyph}
        </svg>
    );
}
